import { AnimatePresence } from 'framer-motion'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import SVG from 'react-inlinesvg'
import Moment from 'react-moment'

import Button from '@/components/Button'
import Icon from '@/components/Icon'
import Modal from '@/components/Modal'
import useCheckout from '@/features/Checkout/hooks/useCheckout'

import { useTheme } from '../../lib/hooks'
import { TopBarAssist, TopBarAssistLabel, TopBarLogin, TopBarTime, TopBarUtils, TopBarWrapper } from './TopBar.styles'

const TopBar = () => {
  const { t } = useTranslation()
  const { callAssistance, setAssistance } = useCheckout()
  const [showLogin, setShowLogin] = useState(false)

  const handleAssistance = () => {
    if (!callAssistance) {
      setAssistance(true)
      setTimeout(() => {
        setAssistance(false)
      }, 30000)
    }
  }

  return (
    <TopBarWrapper>
      <TopBarTime>
        <Moment interval={1000} format="HH:mm" />
      </TopBarTime>
      <TopBarUtils>
        <TopBarLogin onClick={() => setShowLogin(true)}>
          <Icon name="lock_muller" />
        </TopBarLogin>
        <TopBarAssist $active={callAssistance} onClick={handleAssistance}>
          <TopBarAssistLabel>
            <Icon name="chat" />
            {t('callAssistance')}
          </TopBarAssistLabel>
          <TopBarAssistLabel>
            <Icon name="checked" />
            {t('assistanceCalled')}
          </TopBarAssistLabel>
        </TopBarAssist>
      </TopBarUtils>
      <AnimatePresence>
        {showLogin && (
          <Modal icon="id" showClose={true} onClose={() => setShowLogin(false)}>
            <h3>{t('scanYourId')}</h3>
            <Button variant="secondary" onClick={() => setShowLogin(false)}>
              {t('back')}
            </Button>
          </Modal>
        )}
      </AnimatePresence>
    </TopBarWrapper>
  )
}

export default TopBar
